import {Image} from '@shopify/hydrogen';
import useEmblaCarousel from 'embla-carousel-react';

export function MobileFooterBanner({items}: any) {
  /* Carousel & button handling */
  const [viewportRef] = useEmblaCarousel({
    align: 'start',
    dragFree: true,
    loop: false,
    containScroll: 'keepSnaps',
  });

  return (
    <div ref={viewportRef} className="w-full">
      <div className="flex items-start justify-between gap-x-25 lg:hidden">
        {items?.map(({image, title, text}: any, i: number) => (
          <div
            key={i}
            className="flex w-2/3 flex-col gap-y-[5px]"
            style={{flex: '0 0 auto'}}
          >
            <div className="h-25 w-25 -translate-x-1">
              <Image
                width="100px"
                height="100px"
                data={image}
                alt={title}
                loading="lazy"
                className="w-full"
              />
            </div>
            <h4 className="richH4 text-orange">{title}</h4>
            <p className="blockH9">{text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
